import request from './request';
import {
  Role,
  UserResume,
  UserRequest,
  Authorization,
  PasswordRequest
} from './@types/account';
import endpoints, { withAppId } from './endpoints';
import { User } from '../reducers/@types/user';

const getAllUsers = async (): Promise<UserResume[]> =>
  request({
    baseURL: process.env.REACT_APP_API_BASE_URL_SECURITY,
    url: withAppId(endpoints.users.getAll),
    method: 'GET'
  });

const getUser = async ({id}: UserRequest): Promise<UserResume> =>
  request({
    baseURL: process.env.REACT_APP_API_BASE_URL_SECURITY,
    url: withAppId(endpoints.users.getUser).replace("{userId}", id),
    method: 'GET'
  });

const getAllRoles = async (): Promise<Role[]> =>
  request({
    baseURL: process.env.REACT_APP_API_BASE_URL_SECURITY,
    url: withAppId(endpoints.users.getRoles),
    method: 'GET'
  });

const updateRole = async (role: Role): Promise<boolean> =>
  request({
    baseURL: process.env.REACT_APP_API_BASE_URL_SECURITY,
    url: withAppId(endpoints.users.updateRole),
    method: 'POST',
    data:{...role, appId: process.env.REACT_APP_ID}
  });

const createRole = async (role: Role): Promise<string> =>
  request({
    baseURL: process.env.REACT_APP_API_BASE_URL_SECURITY,
    url: withAppId(endpoints.users.createRole),
    method: 'POST',
    data:{...role, appId: process.env.REACT_APP_ID}
  });

const createUser = async (user: User): Promise<string> =>
  request({
    baseURL: process.env.REACT_APP_API_BASE_URL_SECURITY,
    url: withAppId(endpoints.users.createUser),
    method: 'POST',
    data: {...user, appId: process.env.REACT_APP_ID}
  });

const updateUser = async (user: User): Promise<string> =>
  request({
    baseURL: process.env.REACT_APP_API_BASE_URL_SECURITY,
    url: withAppId(endpoints.users.updateUser),
    method: 'POST',
    data:{...user, appId: process.env.REACT_APP_ID}
  });

const updatePassword = async (passwordRequest: PasswordRequest): Promise<boolean> =>
  request({
    baseURL: process.env.REACT_APP_API_BASE_URL_SECURITY,
    url: withAppId(endpoints.users.updatePassword),
    method: 'POST',
    data:{...passwordRequest, appId: process.env.REACT_APP_ID}
  });

const activate = async ({id}: UserRequest): Promise<boolean> =>
  request({
    baseURL: process.env.REACT_APP_API_BASE_URL_SECURITY,
    url: withAppId(endpoints.users.activateUser).replace("{userId}", id),
    method: 'POST'
  });

const deactivate = async ({id}: UserRequest): Promise<boolean> =>
  request({
    baseURL: process.env.REACT_APP_API_BASE_URL_SECURITY,
    url: withAppId(endpoints.users.deactivateUser).replace("{userId}", id),
    method: 'POST'
  });

const authorizations = async (): Promise<Authorization[]> =>
  request({
    baseURL: process.env.REACT_APP_API_BASE_URL_SECURITY,
    url: withAppId(endpoints.account.authorizations),
    method: 'GET'
  });

const usersService = {
  getAllUsers,
  getUser,
  getAllRoles,
  activate,
  deactivate,
  updateRole,
  createRole,
  authorizations,
  createUser,
  updateUser,
  updatePassword
};

export default usersService;
